import { createTheme } from '@material-ui/core';

import baseTheme from '@/theme';

export default createTheme({
  ...baseTheme,
  palette: {
    ...baseTheme.palette,
    text: {
      primary: '#163258',
      secondary: '#6A717D',
    },
    primary: {
      light: '#FFB74D',
      main: '#F5A623',
      dark: '#E09300',
      contrastText: '#163258',
    },
    secondary: {
      light: '#234370',
      main: '#163258',
      dark: '#082143',
      contrastText: '#FFFFFF',
    },
  },
  overrides: {
    ...baseTheme.overrides,
    MuiCheckbox: {
      colorSecondary: {
        '&$checked': {
          color: '#163258',
        },
      },
    },
  },
});
